import { useWSModal, WSForm } from "@wingspanhq/fe-component-library";
import { CountryCode } from "libphonenumber-js";
import React from "react";
import * as Yup from "yup";
import { useWSMutation } from "../../../../../query/helpers";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useMemberProfile } from "../../../../../query/users/queries";
import { entityDataService } from "../../../../../shared/services/entityData";
import { WSServiceError } from "../../../../../utils/serviceHelper";
import {
  FormDataPhoneNumber,
  FormPartialPhoneNumber,
  phoneNumberToFormData,
  validationSchemaPhoneNumber
} from "../../../../Onboarding/components/FormPartialPhoneNumber";
import { LayoutFormEdit } from "./LayoutFormEdit";

type FormData = { phone: FormDataPhoneNumber };

type Props = {
  onClose: () => void;
};

export const FormEditBusinessPhoneNumber: React.FC<Props> = props => {
  const userId = useUserId();
  const queryMember = useMemberProfile(userId);

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          phone: data.phone
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onClose
    }
  );

  return (
    <WSForm<FormData>
      onSubmit={mutate}
      validationSchema={Yup.object({
        phone: validationSchemaPhoneNumber
      })}
      defaultValues={{
        phone: queryMember.data?.profile.company?.phoneNumber
          ? phoneNumberToFormData(
              queryMember.data.profile.company.phoneNumber,
              queryMember.data.profile.address?.country as CountryCode
            )
          : undefined
      }}
    >
      <LayoutFormEdit
        isLoading={meta.isLoading}
        error={meta.error}
        onCancel={props.onClose}
      >
        <FormPartialPhoneNumber
          label="Business phone number"
          name="phone"
          required
        />
      </LayoutFormEdit>
    </WSForm>
  );
};

export const useModalEditBusinessPhoneNumber = () =>
  useWSModal(FormEditBusinessPhoneNumber, {
    title: "Business phone number",
    size: "S"
  });
